<div *ngIf="error" class="alert alert-warning">
  {{error}}
</div>
<form class="form signup" [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="row">
    <div class="col-6">
      <form-field class="front" label="First Name" i18n-label="@@front.register.firstName.label">
        <input type="text" formControlName="firstName" data-testid="register-signupForm-firstname-txt" placeholder="Your first Name" i18n-placeholder="@@front.register.firstName.placeholder">
      </form-field>
    </div>
    <div class="col-6">
      <form-field class="front" label="Last Name" i18n-label="@@front.register.lastName.label">
        <input type="text" formControlName="lastName" data-testid="register-signupForm-lastname-txt" placeholder="Your last name" i18n-placeholder="@@front.register.lastName.placeholder">
      </form-field>
    </div>
  </div>
  <form-field class="front" label="Email" i18n-label="@@front.register.email.label">
    <input type="email" formControlName="email" data-testid="register-signupForm-email-txt"  placeholder="Your email address" i18n-placeholder="@@front.register.email.placeholder">
  </form-field>
  <password-complexity
    formControlName="password"
    label="Password"
    data-testid="register-signupForm-password-txt"
    placeholder="Enter your password"
    i18n-label="@@front.register.password.label"
    i18n-placeholder="@@front.register.password.placeholder"
  ></password-complexity>
  <p class="bg-gray text-center">
    <ng-container i18n="@@front.register.agreement">
      By proceeding, you are agreeing to our
      <a routerLink="/page/terms-of-service">Terms of Service</a>
      and
      <a routerLink="/page/privacy-policy">Privacy policy</a>
    </ng-container>
  </p>
  <button type="submit" data-testid="register-signupForm-submit-btn" class="btn btn-front btn-lg btn-primary d-block w-100 mb-3" [disabled]="!form.valid || loading || loadingCaptcha">
    <ng-container *ngIf="loading || loadingCaptcha" i18n="@@front.register.loadingSubmit">Loading ...</ng-container>
    <ng-container *ngIf="!(loadingCaptcha || loading)" i18n="@@front.register.SubmitButton">Sign Up</ng-container>
  </button>
  <div class="bg-gray text-center">
    <ng-container i18n="@@front.register.loginText">Already have an account? <a routerLink="/login">Login</a></ng-container>
  </div>
</form>
